import React from "react";
import { useParent } from "../../../context/ParentContext";

export default function ParentResults() {
  const { selectedChild } = useParent();
  return (
    <div>
      <h4 style={{ marginBottom: 4, color: "#0f172a" }}>Result Card</h4>
      <p style={{ color: "#64748b", fontSize: 13 }}>
        {selectedChild
          ? `Viewing results for ${selectedChild.student?.name}`
          : "No child selected"}
      </p>
      {/* TODO: fetch and display exam results */}
    </div>
  );
}
